export default function Videos() {
  return (
    <section id="videos" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif text-5xl text-white mb-4">
            Videos
          </h2>
          <p className="text-amber-100 text-lg">
            More videos coming soon...
          </p>
        </div>
      </div>
    </section>
  );
}
